import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

export const sharedColors: CSSObject = {
  avatarBorderColor: '#ebebeb',
  darkGreyText: '#262626',
  emptyCollab: colors.orange.base,
  horizontalBorderColor: '#efefef',
  imageBackground: 'black',
  lightGreyBorder: '#d8d8d8',
  lightGreyText: '#a2a2a2',
  mediumGreyText: '#8e8e8e',
  semiOpaqueGrey: 'rgba(0,0,0,0.2)',
}
